import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getRemoteViewLinks() {
        return Axios.get(`${baseURL}schedule/generate-remote-link`).then(
            response => response.data.response
        );
    },
    getCensusList(params) {
        return Axios.get(`${baseURL}schedule/census`, {
            params: params
        }).then(response => response.data.response);
    },
    getRemoteCensusList(params) {
        return Axios.get(`${baseURLci}welcome/censusRemote`, {
            params: params
        }).then(response => response.data.response);
    },
    getAppointmentsForTreatmentBoard(patientId, timestamp) {
        return Axios.get(
            `${baseURL}patient/${patientId}/appointments-for-treatment-board`,
            {
                params: { date: timestamp }
            }
        ).then(response => response.data.response);
    },
    getMedicalNoteList(appointmentId) {
        return Axios.get(
            `${baseURL}schedule/appointment/soap-list/${appointmentId}`
        ).then(response => response.data.response);
    },
    updateAppointmentMedicalNote(appointmentId, params) {
        return Axios.post(
            `${baseURL}schedule/appointment/${appointmentId}/assign-soap`,
            params
        ).then(response => response.data.response);
    },
    sendResentPrevisitDocument(appointmentId) {
        return Axios.post(
            `${baseURL}schedule/appointment/pre-visit/${appointmentId}`
        ).then(response => response.data.response);
    }
};
